module.exports = __webpack_public_path__ + "img/1.41c1c01e.jpg";